// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call_api.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import { file_call_call_errors } from './call/call_errors_pb';
import { file_call_call_model } from './call/call_model_pb';
import type { RealtimeCallEvent } from './call/call_realtime_events_pb';
import { file_call_call_realtime_events } from './call/call_realtime_events_pb';
import type {
  CreatePermissionRequestRequest,
  FinishForAllRequest,
  GetCallByIdRequest,
  GetCallLinkRequest,
  GetCallMembersByCameraOrScreenIdsRequest,
  GetCallMembersByIdsRequest,
  GetCallMembersRequest,
  GetCallPermissionsRequest,
  JoinToCallRequest,
  WaitingRoomAccessRequest,
} from './call/call_requests_pb';
import { file_call_call_requests } from './call/call_requests_pb';
import type {
  CreatePermissionRequestResponse,
  FinishForAllResponse,
  GetCallByIdResponse,
  GetCallLinkResponse,
  GetCallMembersByCameraOrScreenIdsResponse,
  GetCallMembersByIdsResponse,
  GetCallMembersResponse,
  GetCallPermissionsResponse,
  JoinToCallResponse,
  WaitingRoomAccessResponse,
} from './call/call_responses_pb';
import { file_call_call_responses } from './call/call_responses_pb';
import type { BooleanResponse } from './common/common_responses_pb';
import { file_common_common_responses } from './common/common_responses_pb';
import type { CommonErrorResponse } from './error/error_responses_pb';
import { file_error_error_responses } from './error/error_responses_pb';

/**
 * Describes the file call_api.proto.
 */
export const file_call_api: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_error_error_responses,
      file_call_call_requests,
      file_call_call_responses,
      file_call_call_model,
      file_call_call_realtime_events,
      file_call_call_errors,
      file_common_common_responses,
    ]
  );

/**
 * /calls/{channel_id}/connect?token={access_token}
 * Example: ws://localhost:8080/calls/123/connect
 *
 * @generated from message com.gem.vcs.contract.CallWsRequest
 */
export type CallWsRequest = Message<'com.gem.vcs.contract.CallWsRequest'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.CallWsRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallRequest request = 1;
         */
        value: CallRequest;
        case: 'request';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CallWsRequest.
 * Use `create(CallWsRequestSchema)` to create a new message.
 */
export const CallWsRequestSchema: GenMessage<CallWsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_api, 0);

/**
 * @generated from message com.gem.vcs.contract.CallWsResponse
 */
export type CallWsResponse = Message<'com.gem.vcs.contract.CallWsResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.CallWsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.RealtimeCallEvent event = 1;
         */
        value: RealtimeCallEvent;
        case: 'event';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallResponse response = 2;
         */
        value: CallResponse;
        case: 'response';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CallWsResponse.
 * Use `create(CallWsResponseSchema)` to create a new message.
 */
export const CallWsResponseSchema: GenMessage<CallWsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_api, 1);

/**
 * @generated from message com.gem.vcs.contract.CallRequest
 */
export type CallRequest = Message<'com.gem.vcs.contract.CallRequest'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from oneof com.gem.vcs.contract.CallRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.JoinToCallRequest joinToCall = 3;
         */
        value: JoinToCallRequest;
        case: 'joinToCall';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.FinishForAllRequest finishForAll = 4;
         */
        value: FinishForAllRequest;
        case: 'finishForAll';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallPermissionsRequest getCallPermissions = 11;
         */
        value: GetCallPermissionsRequest;
        case: 'getCallPermissions';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CreatePermissionRequestRequest createPermissionRequest = 15;
         */
        value: CreatePermissionRequestRequest;
        case: 'createPermissionRequest';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersRequest getCallMembers = 19;
         */
        value: GetCallMembersRequest;
        case: 'getCallMembers';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsRequest getCallMembersByCameraOrScreenIds = 20;
         */
        value: GetCallMembersByCameraOrScreenIdsRequest;
        case: 'getCallMembersByCameraOrScreenIds';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallByIdRequest getCallById = 21;
         */
        value: GetCallByIdRequest;
        case: 'getCallById';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallLinkRequest getCallLink = 24;
         */
        value: GetCallLinkRequest;
        case: 'getCallLink';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.WaitingRoomAccessRequest waitingRoomAccess = 27;
         */
        value: WaitingRoomAccessRequest;
        case: 'waitingRoomAccess';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallPingRequest ping = 28;
         */
        value: CallPingRequest;
        case: 'ping';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersByIdsRequest getCallMembersByIds = 29;
         */
        value: GetCallMembersByIdsRequest;
        case: 'getCallMembersByIds';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CallRequest.
 * Use `create(CallRequestSchema)` to create a new message.
 */
export const CallRequestSchema: GenMessage<CallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_api, 2);

/**
 * @generated from message com.gem.vcs.contract.CallResponse
 */
export type CallResponse = Message<'com.gem.vcs.contract.CallResponse'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: string traceId = 23;
   */
  traceId: string;

  /**
   * @generated from oneof com.gem.vcs.contract.CallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CommonErrorResponse error = 2;
         */
        value: CommonErrorResponse;
        case: 'error';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.JoinToCallResponse joinToCall = 3;
         */
        value: JoinToCallResponse;
        case: 'joinToCall';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.FinishForAllResponse finishForAll = 4;
         */
        value: FinishForAllResponse;
        case: 'finishForAll';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallPermissionsResponse getCallPermissions = 11;
         */
        value: GetCallPermissionsResponse;
        case: 'getCallPermissions';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CreatePermissionRequestResponse createPermissionRequest = 15;
         */
        value: CreatePermissionRequestResponse;
        case: 'createPermissionRequest';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersResponse getCallMembers = 19;
         */
        value: GetCallMembersResponse;
        case: 'getCallMembers';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsResponse getCallMembersByCameraOrScreenIds = 20;
         */
        value: GetCallMembersByCameraOrScreenIdsResponse;
        case: 'getCallMembersByCameraOrScreenIds';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallByIdResponse getCallById = 21;
         */
        value: GetCallByIdResponse;
        case: 'getCallById';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallLinkResponse getCallLink = 24;
         */
        value: GetCallLinkResponse;
        case: 'getCallLink';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.WaitingRoomAccessResponse waitingRoomAccess = 27;
         */
        value: WaitingRoomAccessResponse;
        case: 'waitingRoomAccess';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.CallPongResponse pong = 28;
         */
        value: CallPongResponse;
        case: 'pong';
      }
    | {
        /**
         * @generated from field: com.gem.vcs.contract.GetCallMembersByIdsResponse getCallMembersByIds = 29;
         */
        value: GetCallMembersByIdsResponse;
        case: 'getCallMembersByIds';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CallResponse.
 * Use `create(CallResponseSchema)` to create a new message.
 */
export const CallResponseSchema: GenMessage<CallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_api, 3);

/**
 * @generated from message com.gem.vcs.contract.CallPingRequest
 */
export type CallPingRequest = Message<'com.gem.vcs.contract.CallPingRequest'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallPingRequest.
 * Use `create(CallPingRequestSchema)` to create a new message.
 */
export const CallPingRequestSchema: GenMessage<CallPingRequest> =
  /*@__PURE__*/
  messageDesc(file_call_api, 4);

/**
 * @generated from message com.gem.vcs.contract.CallPongResponse
 */
export type CallPongResponse = Message<'com.gem.vcs.contract.CallPongResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.CallPongResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.CallPongResponse.
 * Use `create(CallPongResponseSchema)` to create a new message.
 */
export const CallPongResponseSchema: GenMessage<CallPongResponse> =
  /*@__PURE__*/
  messageDesc(file_call_api, 5);
